import React from 'react';
import './BoolQuestionWithDetail.css'

class BoolQuestionWithDetail extends React.Component {


    constructor(){
        super()
        this.state = {
            isModified:false,
            value:null,
            otherValue: null
        }
    }

    handleClick = (evt) => {
        const value = evt.target.value === "true" ? true : false;
        const { field } = this.props;
        let { otherValue } = this.state;
        if(!value){
            otherValue = "";
        }
        
        //Pivot to father
        this.props.handleChangeListener(field, value);
    }

    handleOtherValueChange = (evt) => {
        const otherValue = evt.target.value;
        const { otherField } = this.props;
        //Pivot to father
        this.props.handleChangeListener(otherField, otherValue);
    }


    render() {
            let {field, text, predefinedValue, 
                predefinedOtherValue, isError, errors,
                otherText, valueForOther, note, value, otherValue } = this.props;

            let { isModified } = this.state;

            let errorList = null;
            if(errors !== null){
                errorList = errors !== null? errors.map( (error) =>  <li key={error}>{error}</li>) : null
            }

            if(isModified){
                predefinedValue = value;
            }
            return (
                <div className="row">
                    <div className="col-md-12">
                        <label>{text}</label>
                    </div>
                    <div className="col-md-2">
                        <div className="vertical-separator-20px"></div>
                        <div className="vertical-separator-10px"></div>

                        <div className="">
                            { predefinedValue === true? 
                                <input 
                                    type="radio" 
                                    className="separationBetweenRadioButton"
                                    id={`${field}-si`}
                                    name={field}
                                    checked
                                    value={true}
                                    onChange={this.handleClick}
                                />
                                :
                                <input 
                                    type="radio" 
                                    className="separationBetweenRadioButton"
                                    id={`${field}-si`}
                                    name={field}
                                    value={true}
                                    onChange={this.handleClick}
                                />
                            }
                            <label htmlFor={`${field}-si`}>Sí</label>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="vertical-separator-20px"></div>
                        <div className="vertical-separator-10px"></div>

                        <div className="">
                            { predefinedValue === false? 
                                <input 
                                    type="radio" 
                                    className="separationBetweenRadioButton"
                                    id={`${field}-no`}
                                    name={field}
                                    checked   
                                    value={false}
                                    onChange={this.handleClick}
                                />
                                :
                                <input 
                                    type="radio" 
                                    className="separationBetweenRadioButton"
                                    id={`${field}-no`}
                                    name={field}
                                    value={false}
                                    onChange={this.handleClick}

                                />
                            }
                            <label htmlFor={`${field}-no`}>No</label>
                        </div>
                    </div>
                    { value === valueForOther ?
                        <div className="col-md-8">
                            <div className="form-group">
                                <label htmlFor="exampleInputEmail1"><small>{otherText}</small></label>
                                <input type="text" 
                                    className="form-control"
                                    name={`field-otherValue`}
                                    defaultValue={predefinedOtherValue}
                                    value={otherValue}
                                    onChange={this.handleOtherValueChange}
                                    />
                            </div>
                        </div>
                        :
                        null
                    }
                    <div className="col-md-12">
                        <p className="question-subinstruction">{note}</p>
                        {isError === true ? 
                            <ul className="error">
                            {errorList}
                            </ul>
                            : null
                        }
                    </div>
                </div>
            )
    }

  
}

export default BoolQuestionWithDetail;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/BoolQuestionWithDetail.js